// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"0fdf63a1","453":"49046706","879":"08232f80"}[chunkId] + ".chunk.js";
};